var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye_open_svg__clip0_435_1294)",
    fill: "#3A92E5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4c-7.35.1-9 5.28-9 5.28s1.63 5.17 9 5.34c7.38-.17 9-5.34 9-5.34S16.35 4.1 9 4zm0 9.38a4.07 4.07 0 113.88-4.07A4 4 0 019 13.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.91c1.38 0 2.5-1.164 2.5-2.6 0-1.436-1.12-2.6-2.5-2.6s-2.5 1.164-2.5 2.6c0 1.436 1.12 2.6 2.5 2.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye_open_svg__clip0_435_1294"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 4)",
    d: "M0 0h18v10.62H0z"
  })))));
}
export default SvgEyeOpen;